import { FC } from 'react'
import * as styles from 'components/features/pfm/Donut/Donut.styl'
import * as cn from 'classnames'

const VIEWBOX_SIZE = 200
const HALF_SIZE = VIEWBOX_SIZE / 2
const RADIUS = HALF_SIZE / 2
const CIRCLE_LENGTH = 2 * Math.PI * RADIUS

export type DonutProps = {
  ratio: number
  className?: string
}

export const Donut: FC<DonutProps> = (props) => {
  const { ratio, className } = props
  const strokeOffset = CIRCLE_LENGTH - CIRCLE_LENGTH * ratio

  return (
    <svg
      viewBox={ `0 0 ${ VIEWBOX_SIZE } ${ VIEWBOX_SIZE }` }
      className={ cn(styles.container, className) }
    >
      <circle
        cx={ HALF_SIZE }
        cy={ HALF_SIZE }
        r={ RADIUS }
        fill='transparent'
        stroke='currentColor'
        strokeWidth={ HALF_SIZE }
        strokeDasharray={ CIRCLE_LENGTH }
        strokeDashoffset={ strokeOffset }
      />
    </svg>
  )
}
